import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../translations/translations';

const Testimonials = () => {
  const location = useLocation();
  const { language } = useLanguage();
  const t = translations[language];
  const isROPage = location.pathname === '/ro';
  const [currentIndex, setCurrentIndex] = useState(0);

  const testimonials = isROPage ? [
    {
      id: 1,
      name: t.roTestimonial1Name,
      role: t.roTestimonial1Role,
      location: language === 'en' ? 'Gorakhpur' : 'गोरखपुर',
      rating: 5,
      text: t.roTestimonial1Text,
      image: '👨‍💼'
    },
    {
      id: 2,
      name: t.roTestimonial2Name,
      role: t.roTestimonial2Role,
      location: language === 'en' ? 'Raptinagar' : 'राप्तीनगर',
      rating: 5,
      text: t.roTestimonial2Text,
      image: '👩‍💼'
    },
    {
      id: 3,
      name: t.roTestimonial3Name,
      role: t.roTestimonial3Role,
      location: language === 'en' ? 'Gorakhpur' : 'गोरखपुर',
      rating: 5,
      text: t.roTestimonial3Text,
      image: '👨‍🔧'
    },
    {
      id: 4,
      name: t.roTestimonial4Name,
      role: t.roTestimonial4Role,
      location: language === 'en' ? 'Gorakhpur' : 'गोरखपुर',
      rating: 5,
      text: t.roTestimonial4Text,
      image: '👩‍🏫'
    },
    {
      id: 5,
      name: t.roTestimonial5Name,
      role: t.roTestimonial5Role,
      location: language === 'en' ? 'Gorakhpur' : 'गोरखपुर',
      rating: 5,
      text: t.roTestimonial5Text,
      image: '👨‍🍳'
    }
  ] : [
    {
      id: 1,
      name: t.testimonial1Name,
      role: t.testimonial1Role,
      location: language === 'en' ? 'Gorakhpur' : 'गोरखपुर',
      rating: 5,
      text: t.testimonial1Text,
      image: '👨‍💼'
    },
    {
      id: 2,
      name: t.testimonial2Name,
      role: t.testimonial2Role,
      location: language === 'en' ? 'Raptinagar' : 'राप्तीनगर',
      rating: 5,
      text: t.testimonial2Text,
      image: '👩‍💼'
    },
    {
      id: 3,
      name: t.testimonial3Name,
      role: t.testimonial3Role,
      location: language === 'en' ? 'Gorakhpur' : 'गोरखपुर',
      rating: 5,
      text: t.testimonial3Text,
      image: '👨‍🔧'
    },
    {
      id: 4,
      name: t.testimonial4Name,
      role: t.testimonial4Role,
      location: language === 'en' ? 'Gorakhpur' : 'गोरखपुर',
      rating: 5,
      text: t.testimonial4Text,
      image: '👩‍🏫'
    },
    {
      id: 5,
      name: t.testimonial5Name,
      role: t.testimonial5Role,
      location: language === 'en' ? 'Gorakhpur' : 'गोरखपुर',
      rating: 5,
      text: t.testimonial5Text,
      image: '👨‍🍳'
    }
  ];

  const nextTestimonial = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  // Auto-rotate testimonials
  React.useEffect(() => {
    const interval = setInterval(nextTestimonial, 5000);
    return () => clearInterval(interval);
  }, []);

  const currentTestimonial = testimonials[currentIndex];

  const borderColor = isROPage ? 'border-blue-500/50' : 'border-green-500/50';
  const textColor = isROPage ? 'text-blue-400' : 'text-green-400';
  const gradientColor = isROPage ? 'from-blue-400 to-cyan-400' : 'from-green-400 to-cyan-400';
  const gradientLine = isROPage ? 'from-blue-500 to-cyan-500' : 'from-green-500 to-cyan-500';
  const bgColor = isROPage ? 'bg-gradient-to-b from-white via-blue-50 to-cyan-50' : 'bg-black';
  const textMain = isROPage ? 'text-gray-900' : 'text-white';
  const textSecondary = isROPage ? 'text-gray-600' : 'text-gray-400';
  const cardBg = isROPage ? 'bg-white shadow-xl' : 'bg-gray-900/80 backdrop-blur-sm';
  const avatarGradient = isROPage ? 'from-blue-500 to-cyan-500' : 'from-green-500 to-cyan-500';
  const buttonBg = isROPage ? 'bg-blue-100 border-blue-500/50 hover:bg-blue-200' : 'bg-gray-800 border-green-500/50 hover:bg-green-500/20';
  const indicatorActive = isROPage ? 'bg-blue-500' : 'bg-green-500';
  const indicatorInactive = isROPage ? 'bg-gray-300 hover:bg-gray-400' : 'bg-gray-700 hover:bg-gray-600';

  return (
    <section className={`py-24 ${bgColor} relative overflow-hidden ${isROPage ? 'text-gray-900' : 'text-white'}`}>
      {/* Background Pattern */}
      {!isROPage && (
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 left-0 w-full h-full security-grid opacity-5"></div>
          {/* Multiple Camera Feeds */}
          <div className="absolute top-10 left-10 w-32 h-24 bg-gray-800 border-2 border-green-500/30 rounded animate-flicker">
            <div className="absolute top-1 left-1 flex items-center space-x-1">
              <div className="w-1 h-1 bg-red-500 rounded-full animate-pulse"></div>
              <span className="text-[8px] text-green-400 font-mono">CAM 1</span>
            </div>
          </div>
          <div className="absolute top-10 right-10 w-32 h-24 bg-gray-800 border-2 border-green-500/30 rounded animate-flicker" style={{ animationDelay: '0.5s' }}>
            <div className="absolute top-1 left-1 flex items-center space-x-1">
              <div className="w-1 h-1 bg-red-500 rounded-full animate-pulse"></div>
              <span className="text-[8px] text-green-400 font-mono">CAM 2</span>
            </div>
          </div>
          <div className="absolute bottom-10 left-10 w-32 h-24 bg-gray-800 border-2 border-green-500/30 rounded animate-flicker" style={{ animationDelay: '1s' }}>
            <div className="absolute top-1 left-1 flex items-center space-x-1">
              <div className="w-1 h-1 bg-red-500 rounded-full animate-pulse"></div>
              <span className="text-[8px] text-green-400 font-mono">CAM 3</span>
            </div>
          </div>
          <div className="absolute bottom-10 right-10 w-32 h-24 bg-gray-800 border-2 border-green-500/30 rounded animate-flicker" style={{ animationDelay: '1.5s' }}>
            <div className="absolute top-1 left-1 flex items-center space-x-1">
              <div className="w-1 h-1 bg-red-500 rounded-full animate-pulse"></div>
              <span className="text-[8px] text-green-400 font-mono">CAM 4</span>
            </div>
          </div>
        </div>
      )}
      {isROPage && (
        <div className="absolute inset-0 opacity-5">
          <div className="absolute inset-0 water-wave"></div>
        </div>
      )}

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-16">
          <div className={`inline-block px-6 py-2 ${isROPage ? 'bg-blue-100 border-2 border-blue-400' : 'bg-black/60 border-2 border-green-500/50'} rounded mb-6`}>
            <span className={`${isROPage ? 'text-blue-700' : textColor} font-semibold font-mono text-sm tracking-wider`}>{t.testimonialsBadge}</span>
          </div>
          <h2 className={`text-5xl md:text-6xl font-extrabold mb-6 font-mono ${textMain}`}>
            {t.testimonialsTitle} <span className={`bg-gradient-to-r ${gradientColor} bg-clip-text text-transparent`}>{t.testimonialsTitle2}</span>
          </h2>
          <p className={`text-xl md:text-2xl ${textSecondary} max-w-3xl mx-auto font-mono`}>
            {t.testimonialsSubtitle}
          </p>
          <div className={`w-24 h-1 bg-gradient-to-r ${gradientLine} mx-auto mt-6 rounded-full`}></div>
        </div>

        <div className="max-w-4xl mx-auto">
          {/* Main Testimonial Card */}
          <div className={`relative ${cardBg} rounded-2xl p-8 md:p-12 border-2 ${borderColor} shadow-2xl transform transition-all duration-500`}>
            <div className="text-center">
              {/* Avatar */}
              <div className={`w-24 h-24 mx-auto mb-6 bg-gradient-to-br ${avatarGradient} rounded-full flex items-center justify-center text-5xl shadow-lg ${isROPage ? '' : 'animate-pulse-glow'}`}>
                {currentTestimonial.image}
              </div>

              {/* Stars */}
              <div className="flex justify-center mb-6 space-x-1">
                {[...Array(currentTestimonial.rating)].map((_, i) => (
                  <svg key={i} className="w-6 h-6 text-yellow-400" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                  </svg>
                ))}
              </div>

              {/* Testimonial Text */}
              <blockquote className={`text-xl md:text-2xl ${isROPage ? 'text-gray-700' : 'text-gray-300'} mb-8 leading-relaxed italic`}>
                "{currentTestimonial.text}"
              </blockquote>

              {/* Customer Info */}
              <div>
                <h4 className={`text-2xl font-bold ${textMain} mb-2 font-mono`}>{currentTestimonial.name}</h4>
                <p className={`${textColor} font-semibold`}>{currentTestimonial.role}</p>
                <p className={`${textSecondary} text-sm mt-1`}>{currentTestimonial.location}</p>
              </div>
            </div>

            {/* Navigation Arrows */}
            <button
              onClick={prevTestimonial}
              className={`absolute left-4 top-1/2 transform -translate-y-1/2 w-12 h-12 ${buttonBg} ${isROPage ? 'border-blue-500/50 hover:border-blue-500' : 'border-green-500/50 hover:border-green-500'} rounded-full flex items-center justify-center ${textColor} transition-all duration-300`}
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
              </svg>
            </button>
            <button
              onClick={nextTestimonial}
              className={`absolute right-4 top-1/2 transform -translate-y-1/2 w-12 h-12 ${buttonBg} ${isROPage ? 'border-blue-500/50 hover:border-blue-500' : 'border-green-500/50 hover:border-green-500'} rounded-full flex items-center justify-center ${textColor} transition-all duration-300`}
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </button>
          </div>

          {/* Testimonial Indicators */}
          <div className="flex justify-center mt-8 space-x-2">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentIndex(index)}
                className={`w-3 h-3 rounded-full transition-all duration-300 ${
                  index === currentIndex
                    ? `${indicatorActive} w-8`
                    : indicatorInactive
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;

